<div class="container my-4" *ngIf="request">
    <h3 class="mb-3">Chi tiết Phiếu Trả Hàng: {{ request.code }}</h3>

    <!-- Thông tin chung -->
    <div class="card mb-1 py-2 px-0">
        <div class="card-header fw-bold">Thông tin chung</div>
        <div class="card-body row">
            <div class="col-md-6">
                <p><strong>Mã phiếu:</strong> {{ request.code }}</p>
                <p><strong>Lý do:</strong> {{ request.reason }}</p>
            </div>
            <div class="col-md-6">
                <p>
                    <strong>Trạng thái:</strong>
                    <span class="badge" [ngClass]="getStatusClass(request.status)">
                        {{ ReturnRequestStatusValue[request.status] }}
                    </span>
                </p>
                <p><strong>Ngày tạo:</strong> {{ request.createdAt | date:'dd-MM-yyyy' }}</p>
                <p><strong>Cập nhật:</strong> {{ request.updatedAt | date:'dd-MM-yyyy' }}</p>
            </div>
        </div>
    </div>

    <!-- Thông tin Order -->
    <div class="card mb-1 py-2 px-0" *ngIf="request.items.length">
        <div class="card-header fw-bold">
            Đơn hàng: {{ request.items[0].orderId }}
        </div>
        <div class="card-body">
            <h6>Sản phẩm trả</h6>
            <div class="table-responsive mb-3">
                <table class="table table-sm table-bordered align-middle">
                    <thead class="table-light">
                        <tr>
                            <th>Tên sản phẩm</th>
                            <th>SKU</th>
                            <th>Giá</th>
                            <th>Số lượng mua</th>
                            <th>Số lượng trả</th>
                            <th>Số Lot</th>
                            <th>Phiếu xuất kho</th>
                            <th>Lý do trả</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of request.items[0].items">
                            
                            <td>
                                {{ getProductInfo(item.productSku)?.name || item.productName || '-' }}
                                <div *ngIf="item.expiredDate && item.expiredDate.trim()">
                                    <span style="font-size: 0.85em;" class="text-muted">Hạn dùng: {{ item.expiredDate }}</span>
                                </div>
                            </td>
                            <td>{{ item.productSku }}</td>
                            <td>{{ (getShipmentInfo(item.productSku, item.productSku)?.price || item.price) | currencySymbol }}</td>
                            <td>{{ getShipmentInfo(item.productSku, item.productSku)?.quantity || item.buyQuantity }}</td>
                            <td>{{ item.quantity }}</td>
                            <td>{{ item.lotNumber || '-' }}</td>
                            <td>{{ item.shipmentCode || '-' }}</td>
                            <td>{{ item.note }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- <h6>Tính toán hoàn tiền</h6>
            <ul>
                <li>Tổng hoàn tiền: <strong>{{ request.items[0].refundCalculation.refundTotal | currency:'VND'
                        }}</strong></li>
            </ul> -->

            <!-- <div *ngIf="request.items[0].refundCalculation.promotionImpacts?.length">
                <h6>Ảnh hưởng khuyến mãi</h6>
                <ul>
                    <li *ngFor="let promo of request.items[0].refundCalculation.promotionImpacts">
                        Mã: {{ promo.voucherCode }} |
                        Mất: {{ promo.voucherLost ? 'Có' : 'Không' }} |
                        Điều chỉnh: {{ promo.adjustment | currency:'VND' }}
                    </li>
                </ul>
            </div> -->
        </div>
    </div>

    <!-- Lịch sử trạng thái -->
    <div class="card mb-1 py-2 px-0">
        <div class="card-header fw-bold">Lịch sử trạng thái</div>
        <div class="card-body table-responsive">
            <table class="table table-bordered table-sm">
                <thead class="table-light">
                    <tr>
                        <th>Trạng thái</th>
                        <th>Ghi chú</th>
                        <th>Người thực hiện</th>
                        <th>Thời gian</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let h of request.history">
                        <td>
                            {{ h.status }}
                        </td>
                        <td>{{ h.note || '-' }}</td>
                        <td>{{ h.createdBy }}</td>
                        <td>{{ h.createdAt | date:'dd-MM-yyyy' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- Resolution -->
    <div class="card mb-1 py-2 px-0" *ngIf="request.resolution">
        <div class="card-header fw-bold">Xử lý</div>
        <div class="card-body">
            <p><strong>Hành động:</strong> {{ request.resolution.action }}</p>
            <p><strong>Ghi chú:</strong> {{ request.resolution.note || '-' }}</p>
            <p><strong>Thời gian xử lý:</strong> {{ request.resolution.processedAt | date:'dd-MM-yyyy' }}</p>
        </div>
    </div>
</div>
